import Section from "@/components/Section2";
import { Certificate } from "./certificate";
import { LandingEntity } from "@/domain";

export const SecondSection = ({ info }: { info: LandingEntity }) => {
  return (
    <Section>
      <div className="flex w-full flex-col-reverse gap-8 py-8 tablet:items-start tablet:py-10 desktop:max-w-xxl desktop:flex-row desktop:items-center desktop:justify-center desktop:gap-20 desktop:py-16 ">
        <div className="flex items-center justify-center">
          <Certificate />
        </div>
        <div className="space-y-5 text-primaryText tablet:space-y-8">
          <h2
            className="text-title1 tablet:text-header3 desktop:text-header2"
            dangerouslySetInnerHTML={{ __html: info.title }}
          ></h2>
          <div className="space-y-4 text-textBody" dangerouslySetInnerHTML={{ __html: info.text }}></div>
        </div>
      </div>
      {/* clickable certificate */}
    </Section>
  );
};
